export const application = {
  INITIALIZE: 'APPLICATION_INITIALIZE',
  REINITIALIZE: 'APPLICATION_REINITIALIZE',
  SET_MENU_HEIGHT: 'APPLICATION_SET_TOP_MENU_HEIGHT',
  SET_PAGE_CODE: 'APPLICATION_SET_PAGE_CODE',
  SET_PAGE_TYPE: 'APPLICATION_SET_PAGE_TYPE',
  ROUTE_CHANGED: 'APPLICATION_ROUTE_CHANGED',
  RESIZE: 'APPLICATION_RESIZE',
  SET_PAGE_CLASSNAME: 'APPLICATION_SET_PAGE_CLASSNAME',
  SHOW_GLOBAL_WIDGET: 'APPLICATION_SHOW_GLOBAL_WIDGET',
  HIDE_GLOBAL_WIDGET: 'APPLICATION_HIDE_GLOBAL_WIDGET',
  CHANGE_LANGUAGE: 'APPLICATION_CHANGE_LANGUAGE',
  CHANGE_CURRENCY: 'APLICATION_CHANGE_CURRENCY',
  CHANGE_ACCOUNT_LANGUAGE: 'APPLICATION_CHANGE_ACCOUNT_LANGUAGE',
  GET_PROMOTIONS: 'APPLICATION_GET_PROMOTIONS',
  SET_PROMOTIONS: 'APPLICATION_SET_PROMOTIONS',
  GET_ELIGIBLE_BONUSES: 'APPLICATION_GET_ELIGIBLE_BONUSES',
  GET_BONUS_AVAILABLE: 'APPLICATION_GET_BONUS_AVAILABLE',
  CLAIM_BONUS: 'APPLICATION_CLAIM_BONUS',
  BONUS_CLAIMED: 'APPLICATION_BONUS_CLAIMED',
  RESET_BONUS_CLAIM_STATUS: 'APPLICATION_RESET_BONUS_STATUS',
  SET_ELIGIBLE_BONUSES: 'APPLICATION_SET_ELIGIBLE_BONUSES',
  SET_AVAILABLE_BONUSES: 'APPLICATION_SET_AVAILABLE_BONUSES',
  GET_PREEURO: 'APPLICATION_GET_PREEURO',
  SET_PREEURO: 'APPLICATION_SET_PREEURO',
  SET_LAST_PRODUCT_ID: 'APPLICATION_SET_LAST_PRODUCT_ID',
  REDEEEM_CODE: 'APPLICATION_REDEEM_CODE',
  REDEEEM_CODE_RESET: 'APPLICATION_REDEEM_CODE_RESET',
  REDEEEM_CODE_RESPONSE: 'APPLICATION_REDEEM_CODE_RESPONSE',
  PUSH_EVENT_LOG: 'APPLICATION_PUSH_EVENT_LOG',
  SET_ROUTER_HISTORY: 'APPLICATION_SET_ROUTER_HISTORY',
  SET_IN_GAME_HEADER_SELECTION: 'APPLICATION_SET_IN_GAME_HEADER_SELECTION',
};

export const authentication = {
  START_APP_AUTH: 'AUTHENTICATION_START_APP_AUTH',
  AUTHENTICATE: 'AUTHENTICATION_AUTHENTICATE',
  CHECK_TOKEN_EXPIRATION: 'AUTHENTICATION_CHECK_TOKEN_EXPIRATION',
  REFRESH_AUTH_TOKEN: 'AUTHENTICATION_REFRESH_AUTH_TOKEN',
  CLEAR: 'AUTHENTICATION_CLEAR',
  ACCOUNT_PROBLEM: 'AUTHENTICATION_ACCOUNT_PROBLEM',
  SET_GLOBAL_ERROR: 'AUTHENTICATION_SET_GLOBAL_ERROR',
};

export const profile = {
  RECEIVED_ACCOUNT: 'PROFILE_RECEIVED_ACCOUNT',
};

export const wallet = {
  GET_WALLET: 'WALLET_GET_WALLET',
  SET_WALLET: 'WALLET_SET_WALLET',
  GET_MONTHLY_SETTLEMENTS: 'WALLET_GET_MONTHLY_SETTLEMENTS',
  SET_MONTHLY_SETTLEMENTS: 'WALLET_SET_MONTHLY_SETTLEMENTS',
  GET_ACTIVITIES: 'WALLET_GET_ACTIVITIES',
  SET_ACTIVITIES: 'WALLET_SET_ACTIVITIES',
  GET_PAYMENT_FEES: 'WALLET_GET_PAYMENT_FEES',
  SET_PAYMENT_FEES: 'WALLET_SET_PAYMENT_FEES',
};
